import { faker } from '@faker-js/faker'

export const ME_CORE_MOCKED_RESPONSE = {
  me: {
    id: faker.string.uuid(),
    email: faker.internet.email(),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    phone: faker.phone.number(),
    staffUserPermissions: JSON.stringify({
      access: '2376844875427930127806318510080',
      corporate: '159723975628756904588584603877376',
      sites: {
        '*': '162259276829213363391578010288127',
      },
    }),
    profileImage: {
      url: `https://picsum.photos/200/200?random=${faker.number.int({ min: 1000, max: 9999 })}`,
    },
  },
}
